import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import * as notificationsActions from '../actions';
import commonUtil from '../../../utils/commonUtil';


const { notificationIcons } = require('./notificationConfig');

@connect(store => ({
  notifications: store.notifications.data,
}),
  { ...notificationsActions })

class MiniNotifications extends Component {
  constructor(props) {
    super(props);
    // this.mouseIn = this.mouseIn.bind(this);
    // this.mouseOut = this.mouseOut.bind(this);
    this.updateNotification = this.updateNotification.bind(this);
  }

  updateNotification = (notificationId, profileId, notificationData) => {
    const { updateNotificationsDetail, loadNotificationsDetail } = this.props;
    updateNotificationsDetail(notificationId, profileId).then((response) => {
      if (response.status.status === 'success') {
        loadNotificationsDetail(this.props.eventId, this.props.profileId).then((res) => {
          /* if (res) {
            const notificationContainer = document.querySelector('#notificacionesMenu');
            if (notificationContainer && notificationContainer.style && notificationContainer.style.display === 'none') {
              notificationContainer.style.display = 'block';
            } else if (notificationContainer && notificationContainer.style) {
              notificationContainer.style.display = 'none';
            }
            if (notificationData.redirectURL) {
              if (notificationData.pageName) {
                browserHistory.push(commonUtil.routeTo(notificationData.redirectURL, [{ pageName: notificationData.pageName }, { eventID: this.props.eventId }]));
              } else {
                browserHistory.push(commonUtil.routeTo(notificationData.redirectURL, [{ eventID: this.props.eventId }]));
              }
            }
          } */
        },
        );
      } else if (response.status === 'failure') {
        this.warning.setMessage(response.body.status.errorMessage);
      }
    });

    // if (notificationData.type === 'Gift_Purchased' && notificationData.type === 'Gift_Purchased_WithOut_Message') {
    //   if ('purchased by self') {
    //     browserHistory.push(commonUtil.routeTo(notificationData.redirectURL, [{ eventID: this.props.eventId, tabName: 'personalPurchase' }]));
    //   } else { browserHistory.push(commonUtil.routeTo(notificationData.redirectURL, [{ eventID: this.props.eventId, tabName: 'received' }])); }
    // }
  }


  // mouseIn = (e) => {
  //   if (this.props.data.isRead === 'true' && document.getElementById(e.target.id)) {
  //     document.getElementById(e.target.id).className = 'information';
  //   }
  // }

  // mouseOut = (e) => {
  //   if (this.props.data.isRead === 'true' && document.getElementById(e.target.id)) {
  //     document.getElementById(e.target.id).className = 'information active';
  //   }
  // }


  typeSelector = (type) => {
    let var1 = '';
    notificationIcons.forEach((n) => {
      if (n[type] !== undefined) {
        var1 = n;
        this.static = var1.template;
      }
    });

    return var1;
  }

  createMarkup = (data) => {
    let txt = '';
    /* eslint-disable */
    if (this.props.data.type !== null && data) {
      txt = data.replace('name', this.props.data.name ? this.props.data.name : "");
      txt = txt.replace('message', this.props.data.message ? this.props.data.message : "");
      txt = txt.replace('itemDisplayName', this.props.data.itemDisplayName);
      txt = txt.replace('count', this.props.data.count);
      txt = txt.replace('image', this.props.data.imageURL);
      return { __html: txt };
    }
    /* eslint-enable */
    return null;
  };
  render() {
    const { data, defaultImageNotifications } = this.props;
    if (!data) return null;
    const var2 = this.typeSelector(data.type);
    const date = data.notificationGeneratedDate ? commonUtil.formatInvitationDate(data.notificationGeneratedDate) : '';
    const defaultNotificationImage = defaultImageNotifications && data.type && defaultImageNotifications[data.type] ? <img src={defaultImageNotifications[data.type]} alt="" /> :<i className={notificationIcons.DEFAULT} />

    return (

      <div
        id={data.notificationId}
        className={data.isRead === 'false' ? 'information active' : 'information'}
        // onMouseEnter={this.mouseIn}
        // onMouseLeave={this.mouseOut}
        onClick={() => { this.updateNotification(data.notificationId, this.props.profileId, var2); }
        }
      >
        <div>
          {
            data.isRead === 'false' && (
                <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 5 5" fill="none">
                  <circle cx="2.5" cy="2.5" r="2.5" fill="#FF0000"/>
                </svg>
            )
          }
        </div>
        <div className="image">
          {data.imageURL ? <img src={data.imageURL} alt="" /> : defaultNotificationImage}
        </div>
        <div className="notification-content">
          <p
            className="message" dangerouslySetInnerHTML={this.createMarkup(var2.template)}
          />
          {commonUtil.formatServiceDate ?
          <React.Fragment>
              <div className="descriptiveText date">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M12.6667 2.66659H12V1.33325H10.6667V2.66659H5.33333V1.33325H4V2.66659H3.33333C2.59333 2.66659 2.00667 3.26659 2.00667 3.99992L2 13.3333C2 14.0666 2.59333 14.6666 3.33333 14.6666H12.6667C13.4 14.6666 14 14.0666 14 13.3333V3.99992C14 3.26659 13.4 2.66659 12.6667 2.66659ZM12.6667 13.3333H3.33333V6.66659H12.6667V13.3333ZM12.6667 5.33325H3.33333V3.99992H12.6667V5.33325ZM6 9.33325H4.66667V7.99992H6V9.33325ZM8.66667 9.33325H7.33333V7.99992H8.66667V9.33325ZM11.3333 9.33325H10V7.99992H11.3333V9.33325ZM6 11.9999H4.66667V10.6666H6V11.9999ZM8.66667 11.9999H7.33333V10.6666H8.66667V11.9999ZM11.3333 11.9999H10V10.6666H11.3333V11.9999Z" fill="#333333"/>
                    </svg>
                      {date}
                  </span>

                  <span>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.99337 0.333252C3.31337 0.333252 0.333374 3.31992 0.333374 6.99992C0.333374 10.6799 3.31337 13.6666 6.99337 13.6666C10.68 13.6666 13.6667 10.6799 13.6667 6.99992C13.6667 3.31992 10.68 0.333252 6.99337 0.333252ZM7.00004 12.3333C4.05337 12.3333 1.66671 9.94658 1.66671 6.99992C1.66671 4.05325 4.05337 1.66659 7.00004 1.66659C9.94671 1.66659 12.3334 4.05325 12.3334 6.99992C12.3334 9.94658 9.94671 12.3333 7.00004 12.3333Z" fill="#333333"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.33337 3.6665H6.33337V7.6665L9.83337 9.7665L10.3334 8.9465L7.33337 7.1665V3.6665Z" fill="#333333"/>
                    </svg>
                      {data.notificationGeneratedTime}
                  </span>
              </div>
          </React.Fragment>
            : null}
        </div>
      </div>
    );
  }
}
export default MiniNotifications;

